import { Link } from '@mna/react'
import React from 'react';
import LoadingScreen from 'features/LoadingScreen'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck } from '@fortawesome/free-solid-svg-icons'
import { faTimes } from '@fortawesome/free-solid-svg-icons'
import { Trans } from 'react-i18next'
import { telemedicineVendors } from "../../../server/triage/constants"
import { checkAndGetLocalStorageValue, checkAndGetSessionStorageValue } from "../../../features/utils";
import i18next from '../../../../src/i18n';

export default ({ state, history, actions, nextStepName = 'Care Service' }) => {
	if (state.triageRequest.supportedModalities == 2) {
		nextStepName = "care-options"
	}
	state.triageRequest.activeMenu = "care-options";
	var beforYouConnectText = state.triageResponse.vendorsList[0].nameLocalization.localizations[0].value === telemedicineVendors.oneEightHundredMD 
								? (i18next.t("findcareoption.Careoptions.telemedicine.videoprompt1800p1")+" "+i18next.t("findcareoption.Careoptions.telemedicine.videoprompt1800p2")+". "+i18next.t("findcareoption.Careoptions.telemedicine.videoprompt1800p3")+". "+i18next.t("findcareoption.Careoptions.telemedicine.videoprompt1800p4")+". "+i18next.t("findcareoption.Careoptions.telemedicine.videoprompttext2"))
								: (i18next.t("findcareoption.Careoptions.telemedicine.videoprompttext1")+i18next.t("findcareoption.Careoptions.telemedicine.videoprompttext2"))
	return (
		<LoadingScreen isLoading={state.isLoading}>
			<div className="row video-prompt-container">
				<div className="col-12 col-lg-3 col-md-2 col-sm-1"> </div>
				<div className="content-width mt-3">
					<div className="standby-page-header standby-page-header-left">
						<h1 className="standby-page-header-title">
							<Trans i18nKey="findcareoption.Careoptions.telemedicine.Beforeweconnectyou">
								Before we connect you
							</Trans>
						</h1>
					</div>
					{state.triageResponse.vendorsList[0].nameLocalization.localizations[0]
						.value === telemedicineVendors.oneEightHundredMD ? (
						<>
							<p><Trans i18nKey="findcareoption.Careoptions.telemedicine.videoprompt1800p1">To arrange this request, we would like to confirm: </Trans></p>
							<ul>
								<li> <Trans i18nKey="findcareoption.Careoptions.telemedicine.videoprompt1800p2">You have access to a US or Canadian phone number </Trans></li>
								<li><Trans i18nKey="findcareoption.Careoptions.telemedicine.videoprompt1800p3">Have access to your e-mail </Trans> </li>
								<li>
									<Trans i18nKey="findcareoption.Careoptions.telemedicine.videoprompt1800p4">
										Are comfortable with installing any apps needed to complete a
										video call
									</Trans></li>
							</ul>
						</>
					) : (
						<p className="row w-form-label-justify">
							<Trans i18nKey="findcareoption.Careoptions.telemedicine.videoprompttext1">
								To arrange this request we would like to confirm you have access
								to your e-mail as well as are comfortable with installing any
								apps as needed to complete the call.
							</Trans>{" "}
						</p>
					)}

					<p className="row w-form-label-justify">
						<Trans i18nKey="findcareoption.Careoptions.telemedicine.videoprompttext2">
							Please note that Wi-Fi access is suggested to prevent any
							cellphone data roaming charges.
						</Trans>
					</p>

					<div className="video-prompt row">
						<div className="col-6 text-right video-prompt-item">
							<button
								className="button video-prompt video-prompt-yes"
								onClick={(e) => {
									//state.triageRequest.activeMenu = "telemedicine-info";
									state.triageRequest.activeMenu = "care-options";
									actions.updateLogTelemedCordination();
									nextStepName = state.isTravelAid2 && (checkAndGetLocalStorageValue("countryname") !== "Canada")
										? "telemed-pharma-prompt" :
										state.isTravelAid2 && (checkAndGetLocalStorageValue("countryname") === "Canada") ? "done"
											: "telemedicine-info";
									history.push(`/find-care-options/${nextStepName}`);
									gtag('set', 'content_group', checkAndGetLocalStorageValue("orgid"));
								}}
								aria-label={beforYouConnectText + " "+ i18next.t("findcareoption.Yes")}
							>
								<div className="icon icon-size-3">
									<FontAwesomeIcon
										style={{ color: "green", fontSize: "25px" }}
										icon={faCheck}
									/>
								</div>
								<div>
									<Trans i18nKey="findcareoption.Yes">Yes</Trans>
								</div>
							</button>
						</div>

						<div className="col-6 text-left video-prompt-item">
							<button
								type="button"
								className="button video-prompt video-prompt-no"
								onClick={(e) => {
									{
										var vendorArrayList = state.triageResponse.vendorsList;
										var vendorSupportedModal =
                          				vendorArrayList[0].accessInformation.virtualAccessInformation
                            			.webAccessReferences[0].supportedModalities;
                            			state.triageRequest.supportedModalities = vendorSupportedModal.length;
										state.triageRequest.supportedModalities == (state.isTravelAid2 && vendorSupportedModal[0] === "Video" || (checkAndGetLocalStorageValue("countryname") === "Canada"))
											? nextStepName = "symptoms"
											: (state.triageRequest.supportedModalities == telemedicineVendors.connectionTypeVideo || state.isTravelAid2 && (checkAndGetLocalStorageValue("countryname") !== "Canada")
												? (nextStepName = "telemed-connectiontype")
												: (nextStepName = state.UserNavigatedToQT
													? "quick-telemedicine-screen"
													: state.isTravelAid2
														? "symptoms"
														: "care-options"));
									}
									gtag('set', 'content_group', checkAndGetLocalStorageValue("orgid"));
									history.push(`/find-care-options/${nextStepName}`);
								}}
								aria-label={beforYouConnectText + " "+ i18next.t("findcareoption.No")}
							>
								<div className="icon icon-size-2">
									<FontAwesomeIcon
										style={{ color: "red", fontSize: "25px" }}
										icon={faTimes}
									/>
								</div>
								<div>
									<Trans i18nKey="findcareoption.No">No</Trans>
								</div>
							</button>
						</div>
					</div>
					<div className="standby-page-header standby-page-header-center">
						<a
							href='#'
							className="standby-button-back"
							onClick={()=>{history.push(state.UserNavigatedToQT ? '/find-care-options/quick-telemedicine-screen'
								: (state.isTravelAid2 && checkAndGetLocalStorageValue("countryname") === "Canada")
									? '/find-care-options/symptoms'
									: (state.isTravelAid2 && checkAndGetLocalStorageValue("countryname") !== "Canada")
										? '/find-care-options/telemed-connectiontype'
										: '/find-care-options/care-options')}}
										onKeyDown={(e)=>{if(e.key === "Spacebar" || e.key === "Enter" || e.key === " "){history.push(state.UserNavigatedToQT ? '/find-care-options/quick-telemedicine-screen'
										: (state.isTravelAid2 && checkAndGetLocalStorageValue("countryname") === "Canada")
											? '/find-care-options/symptoms'
											: (state.isTravelAid2 && checkAndGetLocalStorageValue("countryname") !== "Canada")
												? '/find-care-options/telemed-connectiontype'
												: '/find-care-options/care-options')}}}
						>
							<div className="icon">
								<svg
									version="1.1"
									xmlns="http://www.w3.org/2000/svg"
									width="10"
									height="10"
									viewBox="0 0 1024 1024"
								>
									<path d="M128.033 512.054l448.036-448.036 107.836 107.836-340.099 340.2 340.099 340.2-107.836 107.736-447.836-447.836z" />
								</svg>
							</div>
							<Trans i18nKey="findcareoption.Careoptions.telemedicine.Cancelrequest">
								{" "}
								Cancel Request
							</Trans>
						</a>
					</div>
				</div>
				<div className="col-12 col-lg-3 col-md-2 col-sm-1"> </div>
			</div>
		</LoadingScreen>
	);
}